import './modules/page-header/page-header'; // site header (remove if not required)
import './modules/nav-main/nav-main'; // mobile navigation
import './modules/page-footer/page-footer'; // site footer (remove if not required)


/**
 * If grid-debug class detected, show grid
 */
function gridDebugObserver() {
	console.log('add `grid-debug` to the body class attribute to see the grid in action. ')
	const targetNode = document.getElementsByTagName('body').item(0)
	const config = { attributes: true, childList: false, subtree: false }
	const callback = function(mutationsList, observer) {
		for(const mutation of mutationsList) {
			if (mutation.type === 'attributes') {
				if ( mutation.attributeName == "class" && document.body.classList.contains('grid-debug') ) {
					console.log('adding grid debugger')
					const doc = new DOMParser().parseFromString('<div class="grid gridlines"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>', 'text/html')
					document.body.insertBefore( doc.body.firstElementChild, document.body.firstElementChild )
				} else if ( document.body.firstElementChild.classList.contains('gridlines') ) {
					console.log('removing grid debugger')
					document.body.firstElementChild.remove()
				}
			}
		}
	};
	const observer = new MutationObserver(callback)
	observer.observe(targetNode, config)
}
window.addEventListener('load', gridDebugObserver)